<template>
  <div class="activity" :data-color="activityColor">
    <div class="image d-f ai-c jc-c">
      <img :src="`https://${fqdn}.streamify.io/images/h/120/${activity.metadata.giveaway_image}`" v-if="activity.metadata.giveaway_image" />
      <i :class="activityIcon" v-else />
    </div>
    <div class="d-f ai-c f-w p-y-4 p-l-4 p-r-2 f-1">
      <div class="f-1">
        <div class="state" v-html="activityState"></div>
        <div class="info">
          <h3>{{ activityTitle }}</h3>
          <!--<div class="description" v-html="activityDescription"></div>-->
          <div class="description">
            <template v-if="activity.type === 'note'">
              <div v-html="noteMessage"></div>
            </template>
            <template v-if="activity.type === 'customer.updated'">
              <template v-if="activity.metadata.old_nickname && activity.metadata.new_nickname">
                {{ `From "${activity.metadata.old_nickname}" to "${activity.metadata.new_nickname}"` }}
              </template>
            </template>
            <template v-if="['form.submited', 'form.submitted'].includes(activity.type)">
              Customer submitted to the form <a :href="`/form/${activity.metadata.form_id}`" @click.prevent="$router.push(`/form/${activity.metadata.form_id}`)" class="link blue">{{ activity.metadata.form_title }}</a>
            </template>
            <template v-if="['giveaway.won', 'giveaway.participated', 'giveaway.winner-drawn'].includes(activity.type)">
              <!-- TODO: LINK THIS ALSO -->
              {{ this.activity.metadata.giveaway_title }}
            </template>
          </div>
          <p>
            {{ activity.time | formatdate('YYYY-MM-DD HH:mm')}}
            <template v-if="activity.metadata.broadcast_id">
              in <a :href="`/broadcast/${activity.metadata.broadcast_id}`" @click.prevent="$router.push(`/broadcast/${activity.metadata.broadcast_id}`)" class="link blue">{{ activity.metadata.broadcast_title }}</a>
            </template>
          </p>
        </div>
      </div>
      <dots ref="dot" class="small left-center" v-if="activity.type === 'note'">
        <ul>
          <li @click="deleteNote">
            <i class="icon-close-medium" /> Delete note
          </li>
        </ul>
      </dots>
    </div>
  </div>
</template>

<script>

import Dots from '@/components/Dots.vue';
import { marked } from 'marked';

export default {
  components: {
    Dots,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    customer: {
      type: String,
      required: true,
    },
  },
  computed: {
    activityColor() {
      const { type } = this.activity;
      switch (type) {
        case 'giveaway.participated':
        case 'giveaway.winner-drawn':
        case 'giveaway.won':
          return 'purple';
        case 'customer.opt-out':
          return 'red';
        case 'customer.updated':
        case 'customer.created':
          return 'gray';
        case 'note':
          return 'green';
        case 'form.submitted':
        case 'form.submited':
          return 'orange';
        default:
          return '';
      }
    },
    activityIcon() {
      const { type } = this.activity;
      switch (type) {
        case 'note':
          return 'icon-chat-24';
        case 'customer.opt-out':
          return 'icon-user-opt-out-24';
        case 'form.submitted':
        case 'form.submited':
          return 'icon-edit-pen2';
        case 'giveaway.participated':
        case 'giveaway.winner-drawn':
        case 'giveaway.won':
          return 'icon-gift-24';
        default:
          return 'icon-user-24';
      }
    },
    activityState() {
      const { type } = this.activity;
      switch (type) {
        case 'giveaway.participated':
        case 'giveaway.winner-drawn':
        case 'giveaway.won':
          return 'Participated in giveaway'; // ${this.activity.metadata.giveaway_winner ? '<span>Customer won!</span>' : ''}`;
        case 'customer.opt-out':
          return 'Customer opted out';
        case 'customer.updated':
          return 'Customer updated';
        // case 'customer.created':
        //  return 'Customer created';
        case 'form.submited':
        case 'form.submitted':
          return 'Form submitted';
        case 'note':
          return 'Note added';
        default:
          return '';
      }
    },
    activityTitle() {
      if (this.activity.type === 'customer.updated') {
        if (this.activity.metadata.set_phone) {
          return 'Customer set phone number';
        }
        if (this.activity.metadata.old_nickname && this.activity.metadata.new_nickname) {
          return 'Customer changed nickname';
        }
        if (this.activity.metadata.set_name) {
          return 'Customer set name';
        }
        if (this.activity.metadata.set_opted_in) {
          return 'Customer opted in again';
        }
      }

      if (this.activity.type === 'customer.created') {
        return 'Customer created';
      }

      if (this.activity.type === 'form.submited') {
        // return 'Customer submitted a form';
      }

      if (['giveaway.won', 'giveaway.participated', 'giveaway.winner-drawn'].includes(this.activity.type)) {
        if (this.activity.metadata.giveaway_winner) {
          return 'Customer won!';
        }
        // return this.activity.metadata.giveaway_title;
      }

      return '';
    },
    activityDescription() {
      if (this.activity.type === 'note') {
        // eslint-disable-next-line
        return marked.parse(this.activity.metadata.body);
      }

      if (this.activity.type === 'customer.updated') {
        if (this.activity.metadata.old_nickname && this.activity.metadata.new_nickname) {
          return `From "${this.activity.metadata.old_nickname}" to "${this.activity.metadata.new_nickname}"`;
        }
      }

      if (['giveaway.won', 'giveaway.participated', 'giveaway.winner-drawn'].includes(this.activity.type)) {
        return this.activity.metadata.giveaway_title;
      }

      if (['form.submited', 'form.submitted'].includes(this.activity.type)) {
        return `Customer submitted to the form <a href="" class="link blue">${this.activity.metadata.form_title}</a>`;
      }

      return '';
    },
    noteMessage() {
      return marked.parse(this.activity.metadata.body);
    },
  },
  methods: {
    async deleteNote() {
      const deleted = await this.$store.dispatch('Customers/deleteNote', {
        id: this.customer,
        note: this.activity.metadata.note_id,
      });

      if (!deleted) {
        swal({ title: 'An error occured', text: 'Could not delete note', icon: 'error' });
        return;
      }

      this.$refs.dot.close();

      this.$emit('fetchActivities', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.activity {
  align-items: center;
  display: flex;

  &[data-color="gray"] {
    .state {
      color: #717171;
    }
  }
  &[data-color="blue"] {
    .state {
      color: #2F84FF;
    }
  }
  &[data-color="purple"] {
    .state {
      color: #8000FF;
    }
  }
  &[data-color="green"] {
    .state {
      color: #03c14d;
    }
  }
  &[data-color="red"] {
    .state {
      color: #E60000;
    }
  }
  &[data-color="orange"] {
    .state {
      color: #ff7300;
    }
  }

  .image {
    height: 120px;
    width: 120px;

    @media (min-width: 1024px) {
      width: 150px;
    }

    i {
      color: #C7C7C7;
      font-size: 70px;
    }
  }

  .info {
    h3 {
      font-size: 18px;
      font-weight: 600;
      line-height: 26px;
      margin: 5px 0;
      transition: font-size .5s;

      @media (min-width: 768px) {
        font-size: 20px;
        line-height: 28px;
      }

      @media (min-width: 1280px) {
        font-size: 24px;
        line-height: 32px;
      }
    }
  }
}
</style>

<style lang="scss">
.activity {
  .state {
    font-size: 14px;
    font-weight: 600;
    // margin-bottom: 5px;
    position: relative;
    transition: font-size .5s;
    color: #717171;
    display: flex;
    align-items: center;

    span {
      color: #717171;
      margin-left: 5px;
      font-style: italic;
    }
  }
  .info {
    .description {
      font-size: 15px;
      color: #717171;
      line-height: 24px;
      margin-bottom: 3px;
    }
  }
}
</style>
